import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Button from "../../components/CustomButtons/Button";
import ModalHeader from "../ModalHeader";
import { ThreeDots } from "react-loader-spinner";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import { grayColor } from "assets/jss/material-dashboard-pro-react";

const styles = (theme) => ({
  ...modalStyle(theme),
  ...customSelectStyle(theme),
  fontCenter: {
    textAlign: "center !important",
  },
});

const ChangeProjectModal = ({
  open,
  setOpen,
  changingProject,
  projectOptions,
  handleChangeProjectSelect,
  handleChangeProjectConfirm,
  userDetails,
  currentProject,
}) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      classes={{
        root: classes.modalRoot,
        paper: classes.modal,
      }}
      open={open}
      // TransitionComponent={Transition}
      keepMounted
      onClose={() => setOpen(false)}
      aria-labelledby="classic-modal-slide-title"
      aria-describedby="classic-modal-slide-description"
      fullWidth
      maxWidth={"xs"}
    >
      <ModalHeader
        id="content-modal-slide-title"
        title={t("sidebar_cts.profile_menu.change_project")}
        onClose={() => setOpen(false)}
        closeDisabled={changingProject}
        closeLabel={t("modeling_inputs_v2.drawer.close", "Fechar")}
      />
      <DialogContent
        id="classic-modal-slide-description"
        className={classes.modalBody}
      >
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelling-month" className={classes.selectLabel}>
            {t("change_project.select_project")}
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              getContentAnchorEl: null,
            }}
            classes={{
              select: classes.select,
            }}
            value={currentProject}
            onChange={handleChangeProjectSelect}
            inputProps={{
              name: "projectSelect",
              id: "project-select",
            }}
            disabled={changingProject}
          >
            {projectOptions()}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            marginLeft: "15px",
          }}
        >
          {changingProject && (
            <ThreeDots
              color={grayColor[0]}
              ariaLabel="loading"
              height={10}
              width={25}
            />
          )}
        </div>
        <Button
          onClick={() => handleChangeProjectConfirm()}
          color="client"
          simple
          disabled={
            userDetails &&
            (currentProject === userDetails.implementation_code ||
              changingProject)
          }
        >
          {t("change_project.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ChangeProjectModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  changingProject: PropTypes.bool.isRequired,
  projectOptions: PropTypes.func.isRequired,
  handleChangeProjectSelect: PropTypes.func.isRequired,
  handleChangeProjectConfirm: PropTypes.func.isRequired,
  currentProject: PropTypes.string.isRequired,
  userDetails: PropTypes.object.isRequired,
};

export default ChangeProjectModal;
